import request from '@/utils/request'
// 获取手动推动推送记录
let getRecords=(data)=>request.post('/api/notifyLog/getManualNotifyLogs',data)
// 获取操作记录
let getUserRecords=(data)=>request.post('/api/userLog/getUserLogs',data)

export default {
  getRecords,
  getUserRecords
}